export interface Ok<T> {
  readonly ok: true;
  readonly value: T;
}

export interface Fail {
  readonly ok: false;
  readonly error: string;
}

export type Result<T> = Ok<T> | Fail;

export function ok<T>(value: T): Ok<T> {
  return { ok: true, value };
}

export function fail(error: string): Fail {
  return { ok: false, error };
}

export function isOk<T>(result: Result<T>): result is Ok<T> {
  return result.ok === true;
}

export function isFail<T>(result: Result<T>): result is Fail {
  return result.ok === false;
}
